var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "HKLModal",
    {
      ref: "modal",
      attrs: { size: "small", okBtnAction: "ok", hasCancelBtn: false },
    },
    [
      _c("template", { slot: "title" }, [_vm._t("title")], 2),
      _vm._v(" "),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }